import React from 'react';
import './_styles.scss';
import { Dialog, CloseDialogAction } from '../../../../../common/components/Dialog/Dialog';

const DemoEdgeReleaseNotesDialog = ({ open, onClose, releaseNotes = null }) => {
  if (!releaseNotes) return null;

  const { version, features } = releaseNotes;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={`Release Notes - Version ${version}`}
      maxWidth="md"
      fullWidth
      actions={<CloseDialogAction onClose={onClose} />}
      className="release-notes-dialog"
    >
      <div className="release-notes-content">
        <div className="release-notes-features">
          <h4>What's New:</h4>
          <ul className="features-list">
            {features && features.length > 0 ? (
              features.map((feature, index) => (
                <li key={index} className="feature-item">
                  {feature}
                </li>
              ))
            ) : (
              <li className="no-features">No features listed</li>
            )}
          </ul>
        </div>
      </div>
    </Dialog>
  );
};

export default DemoEdgeReleaseNotesDialog;
